import { TTextTip } from "../../../../components/CustomTeachingBubble/CustomTeachingBubble";

export const tipTexts: TTextTip[] = [
    {
        title: "¿Qué información nos proporciona este análisis?",
        description: "Este análisis nos muestra todos los ratios rolling de nuestras carteras.\n\n" +
                     "¿Y qué significa un ratio 'rolling'? \n Básicamente, estamos hablando de cómo ha evolucionado el rendimiento de nuestras inversiones en ventanas de tiempo móviles, como si estuviéramos desplazando una lupa por un gráfico para ver cómo cambia la rentabilidad en distintos momentos.\n\n" +
                     "Rentabilidades Rolling:\n" +
                     "Si seleccionamos un período de 1 año (1Y), el análisis no se limita sólo al último año completo. En lugar de eso, calcula todas las rentabilidades de 52 semanas consecutivas desde el inicio de la cartera.\n\n" +
                     "Por ejemplo:\n" +
                     "- Del 1 de Enero de 2020 al 1 de Enero de 2021\n" +
                     "- Del 8 de Enero de 2020 al 8 de Enero de 2021\n" +
                     "- Del 15 de Enero de 2020 al 15 de Enero de 2021\n\n" +
                     "¡Y así sucesivamente! Cada semana, el análisis avanza y vuelve a calcular las rentabilidades para esa ventana de tiempo de un año.\n\n" +
                     "Lo mismo sucede si seleccionamos 3 años (3Y), 5 años (5Y), etc."
    },
    {
        title: "¡Atención! ¡Los períodos no son lo que crees!",
        description: "En este análisis, cuando seleccionamos 1Y, 3Y, etc., no significa que estés viendo el último año o los últimos tres años como un bloque fijo.\n\n" +
                     "Lo que realmente estás viendo son todas las ventanas móviles de ese período desde el inicio de la cartera hasta la fecha actual.\n\n" +
                     "Es decir, no estás filtrando por un rango de fechas concreto, sino que estás viendo todas las rentabilidades móviles de ese plazo a lo largo del tiempo."
    },
    {
        title: "¿Cómo interpreto los períodos 'Inicio' y 'YTD'?",
        description: "Aquí las cosas cambian un poco:\n\n" +
                     "- Inicio: Muestra la evolución de la rentabilidad anualizada desde el primer día en que creaste la cartera hasta cada momento en el tiempo. Te permite ver cómo ha ido cambiando esa rentabilidad a lo largo del tiempo.\n\n" +
                     "- YTD (Year To Date): Refleja la rentabilidad acumulada desde el comienzo del año hasta el día de hoy.\n\n" +
                     "Ambos indicadores son fijos en su punto de partida, a diferencia de los plazos rolling que son móviles."
    },
    {
        title: "¿Qué son los datos de la tabla?",
        description: "Los datos que ves en la tabla dependen del período que hayas seleccionado.\n\n" +
                     "Aquí se reflejan los últimos valores de todos los ratios de tu cartera o carteras, incluyendo rentabilidad, volatilidad, mayor caída, entre otros.\n\n" +
                     "Si tienes varias carteras, puedes seleccionarlas en el menú desplegable para comparar sus resultados de forma rápida y sencilla."
    },
    {
        title: "¿Cada cuánto se actualiza?",
        description: "La cantidad de información que calculamos para todos los clientes es enorme y creemos que una actualización semanal es suficiente.\n\n" +
                     "Cada viernes calcularemos los datos del viernes anterior."
    }
];

export const tipImages: string[] = [
    "/images/tips/fichaCartera/tipImage_01.png",
    "/images/tips/fichaCartera/tipImage_02.png",
    "/images/tips/fichaCartera/tipImage_03.png",
    "/images/tips/fichaCartera/tipImage_04.png",
    "/images/tips/fichaCartera/tipImage_05.png",
]

